<template>
  <Flex
    v-if="selectedResourceIds.length === 1 && primaryResource"
    align="center"
    :gap="0.5"
  >
    <BaseAvatar
      v-if="primaryResource.type === 'employee'"
      :resource="primaryResource"
    />
    <BaseIcon
      v-else
      :name="resourceIcon(primaryResource.type)"
      size="s"
    />
    <BaseText :color="color">{{ primaryResource.name }}</BaseText>
  </Flex>
  <div v-else-if="selectedResourceIds.length > 1">
    <BaseText :color="color">
      {{ `${selectedResourceIds.length} ${$t('global.items.resource', 2)}` }}
    </BaseText>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { computed } from 'vue';
import { resourceIcon } from '@/helpers/formatting';
import { useResourcesStore } from '@/stores/resources';
import type { Resource } from '@/types';

const props = withDefaults(
  defineProps<{
    selectedResourceIds: Resource['id'][];
    color?: 'default' | 'secondary';
  }>(),
  {
    color: 'default',
  },
);

const { resourceById } = useResourcesStore();

const primaryResource = computed(() => {
  const resourceId = props.selectedResourceIds[0];
  return resourceId ? resourceById(resourceId) : null;
});
</script>
